function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8,1.365H3.2a.99658.99658,0,0,0-1,1v4.28a.982.982,0,0,0,.82.98v13.51a1.50446,1.50446,0,0,0,1.5,1.5H19.41a1.511,1.511,0,0,0,1.5-1.5V7.635a.99685.99685,0,0,0,.89-.99V2.365A1.01623,1.01623,0,0,0,20.8,1.365ZM9.84,2.375h4.32v9.39H9.84ZM3.2,2.365H8.84v4.28H3.2Zm16.71,18.77a.50805.50805,0,0,1-.5.5H4.52a.50146.50146,0,0,1-.5-.5V7.645H8.84v4.12a1.00291,1.00291,0,0,0,1,1h4.32a1.00291,1.00291,0,0,0,1-1V7.645h4.75Zm.89-14.49H15.16V2.365H20.8Z"
});

var SvgProductOutline = function SvgProductOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_outline.644aed28.svg";
export { ForwardRef as ReactComponent };